// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".force-show[data-v-89cacf66]{display:block!important}", "",{"version":3,"sources":["webpack://./resources/js/components/forms/Feedback.vue"],"names":[],"mappings":"AAAA,6BAAA,uBAAA","sourcesContent":[".force-show{display:block !important}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
